import { jsx as _jsx } from "react/jsx-runtime";
import BoolFieldDetail from "./detail";
import { FieldViewType } from "../viewType";
export default function BoolFieldList(_a) {
    var fieldName = _a.fieldName, record = _a.record;
    return (_jsx(BoolFieldDetail, { fieldName: fieldName, record: record, viewType: FieldViewType.DETAIL }));
}
